import React, { useEffect, useRef, useState } from 'react';
import './Amenities.css';
import { FaArrowRight } from 'react-icons/fa'; // Icon import kiya
import logo from '../../assets/images/logo1.png';

const Amenities = () => {
  const sectionRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [result, setResult] = useState(""); // Web3Forms status message

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setResult("");
  };

  // Web3Forms Submission Logic
  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    // Using your Access Key
    formData.append("access_key", "68f8c92b-95f6-4539-bca9-456711228405");
    formData.append("subject", "Amenities Inquiry - Know More");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Details Sent Successfully!");
      event.target.reset();
      setTimeout(() => {
        closeModal();
      }, 2500);
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('amenities-visible');
          } else {
            entry.target.classList.remove('amenities-visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const amenityData = [
    "Indoor Gymnasium", "Senior Citizen Sitting Area", "Celebration Zone", 
    "Temple & Tulsi Vrundavan in each flat", "CCTV Surveillance", 
    "Video Door Phone with color screen", "Limited EV Charging Points", 
    "Indoor Games Zone", "Dedicated Society Office", 
    "Elegantly Designed Entrance Lobby", "Fully Automatic Lifts", 
    "Generator Backup for lifts & common areas", "Solar water heating system", 
    "Rainwater harvesting system", "Firefighting system for the building", 
    "Garbage chute"
  ];

  return (
    <section id="amenities" className="amenities-section" ref={sectionRef}>
      <div className="amenities-container">
        <div className="amenities-header">
          <div className="amenity-line"></div>
          <h2 className="amenity-main-title">Amenities</h2>
          <div className="amenity-line"></div>
        </div>

        <p className="amenity-desc">
          At Sentosa Era, every corner is designed for modern living. Enjoy safe, serene spaces for family gatherings and active lifestyles.
        </p>

        <div className="amenity-grid">
          {amenityData.map((item, index) => (
            <div 
              key={index} 
              className="amenity-item"
              style={{ transitionDelay: `${index * 0.05}s` }}
            >
              <div className="icon-box">
                <div className="orange-dot"></div>
              </div>
              <h3 className="amenity-title">{item}</h3>
            </div>
          ))}
        </div>

        <button className="know-more-btn" onClick={openModal}>Know More</button>
      </div>

      {/* --- UPDATED FORM MODAL --- */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            
            <div className="modal-content">
              <div className="modal-logo">
                <img src={logo} alt="Logo" />
              </div>
              <h2 className="enquire-title">Enquire Now</h2>
              
              <form className="modal-form" onSubmit={onSubmit}>
                <input type="text" name="first_name" placeholder="First Name" required />
                <input type="text" name="last_name" placeholder="Last Name" required />
                <input type="email" name="email" placeholder="Email Id" required />
                <input type="tel" name="mobile" placeholder="Mobile No." required />
                
                {/* <select name="project" required className="modal-select">
                  <option value="" disabled selected>Select Project</option>
                  <option value="Sentosa Era">Sentosa Era</option>
                </select> */}

                <div className="checkbox-container">
                  <input type="checkbox" id="amenity-consent" name="consent" required />
                  <label htmlFor="amenity-consent">
                    I hereby authorize to send notification on SMS, Calls, RCS, WhatsApp.
                  </label>
                </div>

                <button type="submit" className="modal-submit-btn">
                  SUBMIT NOW <FaArrowRight style={{marginLeft: '8px'}} />
                </button>
              </form>

              {result && <p className="form-status">{result}</p>}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Amenities;